<template>
	<div class=" ">
		<el-card>
			<div class="add_main_ai_topic hidden_scroll">
				<div class="sub_content_ai_topic hidden_scroll">
					<div class="">
						<el-form
							label-position="right"
							label-width="120px"
							:model="formData"
							:rules="rule"
							ref="formData"
						>
							<span class="add_item_title">AI标题</span>
							<el-form-item
								label="专题名称"
								prop="topic_name"
								class="add_main_item_block"
							>
								<el-input
									v-model="formData.topic_name"
									:disabled="$route.query.type == 'detail'"
								>
								</el-input>
							</el-form-item>
							<el-form-item
								label="核心信息"
								prop="core_info"
								class="add_main_item_block"
							>
								<el-input
									class="custom_input_ai_topic"
									type="textarea"
									placeholder="请输入核心信息，例如专题描述、专题内容等"
									autosize
									v-model="formData.core_info"
								>
								</el-input>
							</el-form-item>
							<el-form-item
								label="设计风格"
								prop="design_style"
								class="add_main_item_block"
							>
								<div
									class="add_main_item_block_checkbox_item add_main_item_block_checkbox_item_flex"
									v-for="(item, index) in design_style_array"
									:label="item.key"
									:key="index"
								>
									<div class="add_main_item_block_checkbox_item_flex_title">
										{{ item.desc }}：
									</div>
									<el-input
										class="custom_input_ai_topic"
										:placeholder="design_style_array[index].placeholder"
										v-model="design_style_array[index].content"
									>
									</el-input>
								</div>
							</el-form-item>
							<el-form-item label="内容模版" class="add_main_item_block">
								<span class="add_main_item_block_checkbox_item_module_desc">
									您可以添加添加多个内容模版，例如：核心进展、时间线、关键数据、各方动态、影响分析、风险提示和延伸阅读等
								</span>
								<!-- 每组的右上角增加红色删除按钮 -->
								<div
									class="add_main_item_block_checkbox_item add_main_item_block_checkbox_item_module"
									v-for="(item, index) in modules"
									:label="item.key"
									:key="index"
								>
									<div class="add_main_item_block_checkbox_item_flex">
										<span class="add_main_item_block_checkbox_item_flex_title">
											模块名称:
										</span>
										<el-input
											class="custom_input_ai_topic"
											placeholder="请填写模块名称"
											v-model="modules[index].name"
										>
										</el-input>
									</div>
									<div class="add_main_item_block_checkbox_item_flex">
										<span class="add_main_item_block_checkbox_item_flex_title">
											模块描述:
										</span>
										<el-input
											class="custom_input_ai_topic"
											placeholder="请填写模块描述"
											v-model="modules[index].desc"
										>
										</el-input>
									</div>
									<!-- 删除按钮 -->
									<div class="add_main_item_block_checkbox_item_flex_del">
										<el-button
											type="danger"
											size="mini"
											@click="removeModule(index)"
										>
											删除
										</el-button>
									</div>
								</div>
								<el-button
									type="primary"
									class="custom_btn_width_140"
									@click="addModule()"
								>
									添加模块
								</el-button>
							</el-form-item>

							<el-form-item
								class="add_main_item_block"
								label="APP/H5封面图片"
								prop="pic"
							>
								<p style="color: red; font-size: 18px">
									尺寸要求：353：126(1:2.8)
								</p>

								<div class="upload_img_div" v-if="formData.pic">
									<img
										style="width: 80%"
										:src="formData.pic"
										@click="uploadPicture(formData.pic, false)"
									/>
									<div class="upload_img_del">
										<img
											@click="removePicture(false)"
											src="../../../assets/images/upload_img_del.png"
										/>
									</div>
								</div>

								<div v-else>
									<div class="el-upload__text">
										<img
											style="width: 100px"
											src="../../../assets/images/uploadImg.png"
											alt=""
											@click="uploadPicture(formData.pic, false)"
										/>
										<br /><em>点击加号上传</em></div
									>
								</div>
								<!-- 剪裁组件弹窗 -->
								<el-dialog
									title=""
									:visible.sync="cropperModel"
									width="1300px"
									center
									:append-to-body="true"
								>
									<template v-if="cropperModel">
										<cropper-image-new
											:Name="cropperName"
											:type="scale"
											:showType="currentShowType()"
											@uploadImgSuccess="handleUploadSuccess"
											ref="child"
										>
										</cropper-image-new>
									</template>
								</el-dialog>
							</el-form-item>

							<el-form-item
								class="add_main_item_block"
								label="PC封面图片"
								prop="pc_pic"
							>
								<p style="color: red; font-size: 18px">
									尺寸要求：780：156(1:5)
								</p>

								<div class="upload_img_div" v-if="formData.pc_pic">
									<img
										style="width: 80%"
										:src="formData.pc_pic"
										@click="uploadPicture(formData.pc_pic, true)"
									/>
									<div class="upload_img_del">
										<img
											@click="removePicture(true)"
											src="../../../assets/images/upload_img_del.png"
										/>
									</div>
								</div>

								<div v-else>
									<div class="el-upload__text">
										<img
											style="width: 100px"
											src="../../../assets/images/uploadImg.png"
											alt=""
											@click="uploadPicture(formData.pc_pic, true)"
										/>
										<br /><em>点击加号上传</em></div
									>
								</div>
							</el-form-item>
							<el-form-item
								label="AI渲染"
								prop="template"
								class="add_main_item_block"
							>
								<div>
									<!-- 放置ai_text的json数据 ,需要展示成json格式-->
									<textarea
										v-if="formData.ai_text"
										class="ai_textjson"
										v-html="formData.ai_text"
									>
									</textarea>
								</div>
								<el-button
									:disabled="isDisabled"
									type="primary"
									class="custom_btn_width_140"
									@click="generateAiTopic()"
								>
									渲染AI专题页面
								</el-button>
								<el-button
									type="primary"
									class="custom_btn_width_120"
									@click="previewAiTopic()"
								>
									预览AI专题页面
								</el-button>
							</el-form-item>

							<div class="flex justify_content_c align_items_c add_left_submit">
								<el-button
									:disabled="isDisabled"
									type="primary"
									class="custom_btn_width_100"
									@click="submit('formData', 1, 1)"
									v-if="$route.query.type != 'detail'"
								>
									确定
								</el-button>
								<el-button
									class="custom_btn_width_100"
									@click="submit('formData', 0, 1)"
									v-if="$route.query.type != 'detail'"
								>
									保存草稿
								</el-button>
								<el-button class="custom_btn_width_100" @click="back">
									取消
								</el-button>
							</div>
						</el-form>
					</div>
				</div>
			</div>
		</el-card>
		<div v-if="loading" class="loading-overlay">
			<!-- loading遮罩内容 -->
			<div class="spinner"></div>
		</div>
	</div>
</template>

<script>
import { myMixin } from "@/utils/mixin.js";
import { getUserId } from "@/utils/auth";

import EditorMine from "../addmessage/Editor.vue";

import zhuanti from "../addmessage/zhuanti.vue";

import {
	generateAiTopic,
	generateAiTopicHtml,
	submitAiTopic,
	getAiTopicDetail,
	getAiTopicList,
} from "@/api/article";
import { uploadImage, getUsersList } from "@/api/user";
import { validateNull } from "@/utils/validate";
import { fixHeadingBlocks } from "@/utils/editorUtils";
import { format } from "echarts";

export default {
	mixins: [myMixin],
	name: "",
	components: {
		EditorMine,
		zhuanti,
	},
	data() {
		return {
			props: { multiple: false },
			rule: {
				topic_name: [
					{ validator: validateNull, trigger: "change", required: true },
				],
				core_info: [
					{ validator: validateNull, trigger: "change", required: true },
				],
			},
			isDisabled: false, // 按钮是否禁用
			loading: false,
			formData: {
				topic_name: "",
				core_info: "",
				design_style: [],
				ai_text: "",
				content: "",
				pic: "",
				pc_pic: "",
			},
			modules: [{ key: "core_updates", desc: "", checked: true, name: "" }],
			design_style_array: [
				{
					key: "整体风格",
					desc: "整体风格",
					placeholder:
						"现代卡片式/科技媒体风/高级极简/杂志化排版/未来感数据界面",
					content: "",
				},
				{
					key: "颜色设定",
					desc: "颜色设定",
					placeholder: "主色调、辅助色、点缀色",
					content: "",
				},
				{
					key: "背景风格",
					desc: "背景风格",
					placeholder: "浅色背景/深色背景/渐变背景/极浅色背景",
					content: "",
				},
				{
					key: "氛围倾向",
					desc: "氛围倾向",
					placeholder: "制理性/未来科技/活跃年轻/高级沉稳",
					content: "",
				},
				{
					key: "质感要求",
					desc: "质感要求",
					placeholder: "玻拟态/扁平化/微阴影卡片/柔和描边/杂志感",
					content: "",
				},
				{
					key: "配色参考规则",
					desc: "配色参考规则",
					placeholder: "专业简/科技感/商务风/活力风",
					content: "",
				},
			],
			//参数
			cropperModel: false,
			cropperName: "",

			scale: "0",
			isPcPic: false,
		};
	},
	watch: {
		"$route.query.id": [
			function handler1() {
				if (!this.$route.query.id) {
					this.clearFormAdd();
				} else {
					this.getAiTopicDetail();
				}
			},
		],
	},
	mounted() {},
	created() {
		if (!this.$route.query.id) {
			this.clearFormAdd();
		} else {
			this.getAiTopicDetail();
		}
	},
	methods: {
		removeModule(index) {
			if (this.modules.length > 1) {
				this.modules.splice(index, 1);
			} else {
				this.$message.error("至少保留一个模块");
			}
		},
		addModule() {
			this.modules.push({
				key: "module" + this.modules.length,
				desc: "",
				checked: true,
				name: "",
			});
		},
		// 根据图片类型和是否为PC封面图片，返回对应的裁剪宽高比
		currentShowType() {
			if (this.isPcPic) {
				return 8;
			}
			return 9;
		},
		previewAiTopic() {
			if (!this.formData.content || this.formData.content.length == 0) {
				this.$message.error("请先生成专题页面");
				return;
			}
			this.$confirm("预览前请确认已经提交保存", "提示", {
				confirmButtonText: "已保存去预览",
				cancelButtonText: "取消",
				type: "warning",
			})
				.then(() => {
					let url = "https://dev.metaera.asia/aitopic/" + this.$route.query.id;
					window.open(url, "预览");
				})
				.catch(() => {
					this.$message({
						type: "info",
						message: "已取消预览",
					});
				});
		},
		generateAiTopicHtml() {
			if (!this.formData.ai_text || this.formData.ai_text.length == 0) {
				this.generateAiTopic();
				return;
			}

			this.loading = true;
			const that = this;
			generateAiTopicHtml(this.formData.ai_text)
				.then((res) => {
					this.loading = false;
					if (res.code == 200) {
						that.formData.content = res.data.html;
						that.$message.success("AI渲染成功");
					} else {
						that.$message.error(res.message);
					}
				})
				.catch((error) => {
					this.loading = false;
					that.$message.error(error.message);
				});
		},
		generateAiTopic() {
			let formData = this.formData;
			if (!formData.topic_name || formData.topic_name.length < 2) {
				this.$message.error("请编辑AI标题");
				return;
			}
			if (
				(!formData.core_info || formData.core_info.length < 2) &&
				formData.type != 2
			) {
				this.$message.error("请编辑核心信息");
				return;
			}

			for (let index = 0; index < this.design_style_array.length; index++) {
				const element = this.design_style_array[index];
				if (!element.content || element.content.length == 0) {
					this.$message.error("请填写" + element.key);
					return;
				}
			}

			this.isDisabled = true; // 禁用按钮
			// 设置一定时间后重新启用按钮
			setTimeout(() => {
				this.isDisabled = false;
			}, 1000); // 1秒后恢复可点击

			this.formData.status = 1;

			this.$refs.formData.validate((valid) => {
				const that = this;
				if (valid) {
					let tmpParam = { ...formData };
					var modules = [];
					for (let index = 0; index < this.modules.length; index++) {
						const element = this.modules[index];
						if (element.checked) {
							if (!element.name || element.name.length == 0) {
								that.$message.error("请填写模块名称");
								return;
							}
							modules.push(element);
						}
					}
					if (modules.length > 0) {
						tmpParam.modules = modules;
					} else {
						that.$message.error("请至少选择一个内容模版");
					}

					tmpParam.design_style = this.design_style_array;

					this.loading = true;
					generateAiTopic(tmpParam)
						.then(async (res) => {
							if (res.code == 200) {
								this.loading = false;
								this.formData.ai_text = res.data;
								this.generateAiTopicHtml();
							} else {
								this.loading = false;
								that.$message.error(res.message);
							}
						})
						.catch((error) => {
							that.$message.error(error);
							this.loading = false;
						});
				} else {
					that.$message.error("缺少必填参数，请根据提示填写！");
					return false;
				}
			});
		},

		removePicture(isPcPic = false) {
			if (isPcPic) {
				this.formData.pc_pic = "";
			} else {
				this.formData.pic = "";
			}
		},
		//封面设置
		uploadPicture(name, isPcPic) {
			this.isPcPic = isPcPic;
			if (this.$route.query.type == "detail") {
				// 详情不支持编辑图片
			} else {
				this.cropperName = name;
				this.cropperModel = true;
			}
		},
		//图片上传成功后
		handleUploadSuccess(data) {
			this.cropperModel = false;
			if (this.isPcPic) {
				this.formData.pc_pic = data.url;
			} else {
				this.formData.pic = data.url;
			}
		},

		// 新增资讯提交
		submit(formName, status, isExit) {
			let formData = this.formData;

			if (!this.$route.query.id) {
			} else {
				formData.id = this.$route.query.id;
			}

			if (!formData.topic_name || formData.topic_name.length < 2) {
				this.$message.error("请编辑AI标题");
				return;
			}
			if (
				(!formData.core_info || formData.core_info.length < 2) &&
				formData.type != 2
			) {
				this.$message.error("请编辑核心信息");
				return;
			}
			if (!formData.pic || formData.pic.length == 0) {
				this.$message.error("请上传封面图片");
				return;
			}
			for (let index = 0; index < this.design_style_array.length; index++) {
				const element = this.design_style_array[index];
				if (!element.content || element.content.length == 0) {
					this.$message.error("请填写" + element.key);
					return;
				}
			}

			this.isDisabled = true; // 禁用按钮
			// 设置一定时间后重新启用按钮
			setTimeout(() => {
				this.isDisabled = false;
			}, 1000); // 1秒后恢复可点击

			this.formData.status = status;

			this.formData.title = formData.ai_text.title;
			this.formData.illustrate = formData.ai_text.summary;

			this.$refs.formData.validate((valid) => {
				const that = this;
				if (valid) {
					let tmpParam = { ...formData };
					var modules = [];
					for (let index = 0; index < this.modules.length; index++) {
						const element = this.modules[index];
						if (element.checked) {
							modules.push(element);
						}
					}
					if (modules.length > 0) {
						tmpParam.modules = modules;
					} else {
						that.$message.error("请至少选择一个内容模版");
					}
					tmpParam.design_style = this.design_style_array;

					this.loading = true;
					submitAiTopic(tmpParam)
						.then(async (res) => {
							if (res.code == 200) {
								that.$message.success("AI文案生成成功");
								this.loading = false;
								this.goBack();
							} else {
								this.loading = false;
								that.$message.error(res.message);
							}
						})
						.catch((error) => {
							that.$message.error(error);
							this.loading = false;
						});
				} else {
					that.$message.error("缺少必填参数，请根据提示填写！");
					return false;
				}
			});
		},
		// 新增 goBack 方法
		goBack() {
			// 优先使用 Vue Router 的 history 判断
			if (
				this.$router.history &&
				this.$router.history.stack &&
				this.$router.history.stack.length > 1
			) {
				console.log("使用 Vue Router 的 history 栈");
				this.$router.back();
			} else if (window.history.length > 1) {
				// 备用方案：使用浏览器原生 history API
				console.log("使用浏览器原生 history API");
				window.history.back();
			} else {
				// 没有历史记录，跳转到默认页面
				this.$router.push({ path: "/message/aitopic" });
			}
		},
		// 获取资讯详情
		getAiTopicDetail() {
			const that = this;
			getAiTopicDetail({ id: that.$route.query.id })
				.then((res) => {
					if (res.code == 200) {
						for (let key in that.formData) {
							that.formData[key] = res.data[key];
						}
						// 字符串转数组
						that.modules = JSON.parse(res.data.modules);
						that.design_style_array = JSON.parse(res.data.design_style);
						that.formData.ai_text = JSON.parse(res.data.ai_text);
					} else {
						that.$message.error(res.message);
					}
				})
				.catch((error) => {
					that.$message.error(error.message);
				});
		},
		back() {
			this.$confirm("取消编辑将丢失已经修改的数据，确认取消编辑吗？", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning",
			})
				.then(() => {
					this.goBack();
				})
				.catch(() => {
					this.$message({
						type: "info",
						message: "已取消返回",
					});
				});
		},
		clearFormAdd() {
			for (let key in this.formData) {
				this.formData[key] = "";
			}
			this.formData.prohibit_tran = "0";
			this.formData.allow_tgpush = "1";
			this.formData.is_top = "0";
			this.formData.is_home = "0";
			this.formData.is_push = "0";
			this.formData.is_recommend = "0";
			this.formData.status = "0";
			this.formData.edit_type = 1;
			this.formData.visits_num = 0;
		},
	},
};
</script>

<style scoped>
.main {
	width: calc(100% - 40px);
}
.upload_img_div {
	display: flex;
}
.upload_img_del {
	margin-left: -15px;
	margin-top: -15px;
}
.upload_img_del img {
	width: 30px;
	height: 30px;
}
.add_main_ai_topic {
	width: 100%;
	height: calc(100vh - 140px);
	margin: 0 auto;
	display: flex;
	margin-top: 20px;
	padding-bottom: 20px;
}

.sub_content_ai_topic {
	margin-left: 15%;
	margin-right: 15%;
	width: 100%;
	padding: 20px; /* 可选：增加内边距使内容不紧贴边框 */
	border-radius: 4px; /* 可选：添加圆角使边框更美观 */
	overflow-y: scroll;
}
.sub_content_right {
	margin-left: 0%;
	margin-right: 20px;
	width: calc(100vw - 210px - 60px - 340px);
	border: 1px solid black; /* 添加边框 */
	padding: 20px; /* 可选：增加内边距使内容不紧贴边框 */
	border-radius: 4px; /* 可选：添加圆角使边框更美观 */

	overflow-y: scroll;
}
</style>
<style>
.el-card__body,
.el-main {
	padding-top: 0 !important;
}
.card_title {
	height: 40px;
}
</style>
<style scoped>
.loading-overlay {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.5); /* 半透明黑色背景 */
	display: flex;
	justify-content: center;
	align-items: center;
}

.spinner {
	/* 样式可以根据需求自行调整 */
	border: 4px solid rgba(255, 255, 255, 0.3);
	border-radius: 50%;
	border-top: 4px solid #fff;
	width: 50px;
	height: 50px;
	animation: spin 1s linear infinite;
}

@keyframes spin {
	0% {
		transform: rotate(0deg);
	}
	100% {
		transform: rotate(360deg);
	}
}
</style>

<style scoped>
.add_item_title {
	font-size: 18px;
	font-weight: 800;
}
</style>

<style>
.add_main_ai_topic .el-form-item__label {
	font-size: 16px;
	text-align: left;
	font-weight: 800;
	width: 190px !important;
}

.add_main_ai_topic .el-form-item__content {
	margin-left: 90px !important;
}

.add_main_item_block .el-form-item__content {
	margin-left: 0px !important;
}

.add_main_ai_topic .el-radio {
	margin-right: 10px;
}

.add_main_ai_topic .el-radio__label {
	font-size: 14px;
	padding-left: 4px;
}

.add_main_ai_topic .el-form-item {
	margin-bottom: 0px;
}
.add_main_ai_topic .el-input__inner {
	border: 1px solid #dcdfe6;
	border-radius: 5px;
}

.add_main_ai_topic .add_left_item_input {
	width: 200px;
}

.add_main_ai_topic .add_left_item_cascader {
	width: 290px;
	margin-top: 10px;
}
</style>
<style scoped>
.add_left_item_zhuanti {
	display: block;
	margin-top: 10px;
}

.add_left_item_zhuanti_header {
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.add_left_item_zhuanti_header_left {
	display: flex;
	align-items: baseline;
}

.add_left_item_zhuanti_header_left_title {
	font-size: 16px;
	font-weight: 800;
	margin-right: 6px;
}

.add_left_item_zhuanti_header_left_count {
	font-size: 12px;
	font-weight: 800;
	margin-right: 6px;
}

.add_left_item_zhuanti_header_right {
	border: 1px solid #dcdfe6;
	width: 40px;
	border-radius: 10px;
	text-align: center;
	font-size: 20px;
	align-items: center;
	align-content: center;
	margin-right: 10px;
}

.add_left_submit {
	margin-left: 0 !important;
	margin-top: 20px;
}
.add_main_item_block {
	display: flex;
	flex-direction: column;
	margin-top: 20px;
}

.add_main_item_block_img {
	display: block;
}
.add_main_item_block_img_text {
	margin-top: 10px;
	font-size: 12px;
	line-height: 20px;
	display: flex;
}

.upload_img_div_add {
	width: 400px;
	aspect-ratio: 16/9;
	border: 1px solid #dcdfe6;
	border-radius: 6px;
	align-content: center;
	align-items: center;
	text-align: center;
}

.upload_img_div_img {
	width: 400px !important;
	height: auto;
}

.upload_img_div_add img {
	width: 40px;
	height: 40px;
	object-fit: cover;
}

.add_main_editor {
	margin-top: 20px;
	height: calc(100vh - 210px);
}

.add_left_item_zhuanti_content {
	border: 1px solid #dcdfe6;
	border-radius: 5px;
	/* height: 36px; */
	padding: 10px 10px;
	margin-right: 10px;
	margin-top: 10px;
	text-align: center;
	align-content: center;
	font-size: 14px;
	font-weight: 600px;
}

.form_tip {
	font-size: 12px;
	color: #999;
	margin-top: 5px;
	margin-bottom: 0;
}

.business-category-group .el-radio {
	margin-bottom: 10px;
	line-height: 1.5;
}

.ai_analysis_section {
	margin-top: 20px;
}

.ai_analysis_header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 10px;
	position: relative;
	z-index: 1;
}

.ai_analysis_header .el-button {
	cursor: pointer;
	pointer-events: auto;
}

.ai_analysis_title {
	font-size: 16px;
	font-weight: 800;
	pointer-events: none;
}

.ai_content_placeholder {
	border: 1px solid #dcdfe6;
	border-radius: 4px;
	padding: 20px;
	text-align: center;
	color: #999;
	background-color: #f5f7fa;
}

.ai_content_editor {
	width: 100%;
}

.add_main_item_block_checkbox_item_module_desc {
	font-size: 12px;
	color: #999;
	margin-top: 5px;
	margin-bottom: 0;
}

.add_main_item_block_checkbox_item_module {
	border: 1px solid #dcdfe6;
	border-radius: 4px;
	padding: 10px;
	margin-bottom: 10px;
}
.add_main_item_block_checkbox_item_module_title {
	font-size: 16px;
	font-weight: 800;
}
.add_main_item_block_checkbox_item_flex {
	display: flex;
	align-items: center;
	margin-top: 10px;
}

.add_main_item_block_checkbox_item_flex_title {
	width: 100px;
}

.add_main_item_block_checkbox_item_flex_line {
	margin-top: 20px;
	margin-bottom: 20px;
	height: 1px;
	background-color: #bbb;
}
</style>
<style>
.add_left_item_zhuanti_dialog .el-dialog {
	display: block;
	background: rgba(0, 0, 0, 0) !important;
}

.add_left_item_zhuanti_dialog .el-dialog__header {
	display: none;
}

.add_left_item_zhuanti_dialog .el-dialog__body {
	padding: 0;
	background: rgba(0, 0, 0, 0);
}
</style>
<style>
.custom_input_ai_topic textarea {
	height: 200px !important;
}
.ai_textjson {
	width: 100%;
	height: 200px;
}
</style>
